import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { verifactuRegularInvoiceSchema } from "./schema";

export const verifactuRegularInvoiceConfig = defineForm({
  id: "verifactu_regular_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.VERIFACTU_REGULAR_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "VeriFactu",
  invoiceType: "regularInvoice",
  complianceType: ComplianceDocumentType.RegularInvoice,
  requiresLegalRep: true,
  titleKey: "regular_invoice",
  complianceStandardKey: "verifactu",
  schema: verifactuRegularInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
